export default class BasePresenter {

    constructor(view) {
        this.view = view;
    }

    tipError(result) {
        if (this.view) {
            this.view.tipError(result);
        }
    }

    showDoingIndicator(text) {
        if (this.view) {
            this.view.showDoingIndicator(text);
        }
    }

    closeDoingIndicator() {
        if (this.view) {
            this.view.closeDoingIndicator();
        }
    }

    showLoadingIndicator(text) {
        if (this.view) {
            this.view.showLoadingIndicator(text);
        }
    }

    closeLoadingIndicator() {
        if (this.view) {
            this.view.closeLoadingIndicator();
        }
    }

    showLoadMoreIndicator(text) {
        if (this.view) {
            this.view.showLoadMoreIndicator(text);
        }

    }

    closeLoadMoreIndicator() {
        if (this.view) {
            this.view.closeLoadMoreIndicator();
        }
    }
}